import { Volume2, VolumeX } from 'lucide-react'
import { useAudio } from '../hooks/useAudio'

export function AudioControls() {
	const { toggleBackgroundMusic, isMusicPlaying } = useAudio()

	return (
		<button
			type="button"
			onClick={toggleBackgroundMusic}
			className="fixed top-16 left-4 z-50 rounded bg-black/40 p-2 text-white transition-all hover:scale-105 hover:bg-black/70"
			title={isMusicPlaying ? 'Pausar música' : 'Tocar música'}
		>
			{isMusicPlaying ? <Volume2 size={24} /> : <VolumeX size={24} />}
		</button>
	)
}
